import React from 'react';
import LocalizedStrings from "react-localization";

let strings = new LocalizedStrings({
    ru: {
        'go_to_group': 'Смотреть группы',
    },
    et: {
        'go_to_group': 'Rühmade kuvamine',
    }
});

export class MapMarker extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        strings.setLanguage(localStorage.getItem('language'))

        return <div className="absolute map-marker" style={{marginTop: "-44px", marginLeft: "-11px"}}>
            <button onClick={this.props.onMarkerClick} className={"relative" + (this.props.isSelected ? ' z-20' : '')} >
                <svg width="22" height="44" viewBox="0 0 22 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M11.6875 44V21.9649C17.4322 21.6074 22 16.8328 22 11C22 4.93488 17.0651 0 11 0C4.93488 0 0 4.93488 0 11C0 16.8328 4.56775 21.6074 10.3125 21.9649V44H11.6875ZM1.375 11C1.375 5.6925 5.6925 1.375 11 1.375C16.3075 1.375 20.625 5.6925 20.625 11C20.625 16.3075 16.3075 20.625 11 20.625C5.6925 20.625 1.375 16.3075 1.375 11Z"
                        fill="#25346D"/>
                    <path
                        d="M1.375 11C1.375 5.6925 5.6925 1.375 11 1.375C16.3075 1.375 20.625 5.6925 20.625 11C20.625 16.3075 16.3075 20.625 11 20.625C5.6925 20.625 1.375 16.3075 1.375 11Z"
                        fill="#E83947"/>

                </svg>
            </button>

            {this.props.isSelected && (
                <div className={"absolute bg-cover bg-no-repeat map-tip z-10" + (!this.props.isSelected ? ' hidden' : '')}>
                    <div className={"text-[#25346D] font-medium text-sm"}>{this.props.name}</div>
                    <div className={"text-[#25346D] font-normal text-sm mb-2"}>{this.props.address}</div>
                    <a href={"/group/register?pool=" + this.props.id} target="_blank"
                       className={"block text-[#1474E0] underline text-sm font-normal hover:no-underline"}>{strings.go_to_group}</a>
                    <button className="absolute top-[27px] right-[30px]" onClick={this.props.onCloseTip}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 18L6 6" stroke="#25346D" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18 6L5.99997 18" stroke="#25346D" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>)}
        </div>;
    }
}
